import React from 'react';
import cx from 'classnames';
import { DateTime } from 'luxon';
import { MinLineGraph } from '@ems/client-design-system';

// Include the 60 seconds either side of the Infringing Operation time and render them on the 1 second sample graph.
export const ProfileGraph = ({
  data,
  currentTime,
  shouldDisplay,
  startTime,
  endTime,
  operationType,
}: any) => {
  if (typeof data === 'undefined' || !data.length) {
    // make sure we have the required data
    return null;
  }

  const convertedStart = DateTime.fromISO(startTime).toSeconds();
  const convertedEnd = DateTime.fromISO(endTime).toSeconds();

  return (
    <div className={cx('noise-graph_container', { 'noise-graph_container--hide': !shouldDisplay })}>
      <MinLineGraph
        data={data}
        count={currentTime}
        startTime={convertedStart}
        endTime={convertedEnd}
        type={operationType}
      />
    </div>
  );
};
